export enum Role {
    MileageClerk = 'MileageClerk',
    Controller = 'Controller',
    PerformanceManager = 'PerformanceManager',
    Reader = 'Reader',
}
